import { QueryResult, useQuery } from '@apollo/client';
import { GET_ROD_FILLER_MATERIALS } from '@bechtel/client-gql';
import { PagingInput, RodFillerMaterialList } from '@bechtel/types';

export function useRodFillerMaterialQuery(
  fetchFromNetwork?: boolean
): QueryResult<{ rodFillerMaterialList: RodFillerMaterialList[]; paging: PagingInput }> {
  const vars = {
    variables: {
      paging: {
        limit: 20,
        cursor: '1',
      },
    },
  };
  const response = useQuery<
    { rodFillerMaterialList: RodFillerMaterialList[]; paging: PagingInput },
    Record<string, any>
  >(
    GET_ROD_FILLER_MATERIALS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
          ...vars,
        }
      : {
          notifyOnNetworkStatusChange: true,
          ...vars,
        }
  );
  return response;
}
